<template>
  <div>
    <router-view />
    <appAlert />
  </div>
</template>

<script>
import appAlert from "@/packages/dashboard/plugins/appAlert/appAlert";
export default {
  name: "ExemptionComponent",
  components: { appAlert },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Exemption/exemptibleUnits");
      window.document.title = "KISEB::Exemptions";
    });
  },
};
</script>

<style scoped></style>
